export default {
    updatePlanners(state, payload){
        state.planners = payload.data
        state.pagination.page = payload.meta.current_page
        state.pagination.rowsPerPage = payload.meta.per_page
        state.totalItems = payload.meta.total
    },
}
